import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ResellerPageStyle } from "../../pages/Reseller/Reseller.styled";
import { useDB } from "../../context/DynamoDBContext";
import {
  BaseStationSchema,
  BeaconSchema,
  ResellerSchmea,
} from "../../validations/ResellerValidations";
import IdListInput from "../Input/IdListInput";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Papa from "papaparse";
import { TextErrorStyle, TextErrorStyle2 } from "../../styles/ErrorStyles";

const AddReseller = ({ visible, setVisible }) => {
  const { dynamoDBClient } = useDB();
  const [resellerID, setResellerID] = useState("");
  const [resellerIDError, setResellerIDError] = useState(false);
  const [resellerIDStatement, setResellerIDStatement] = useState("");
  const [baseStationIDError, setBaseStationIDError] = useState(false);
  const [baseStationIDStatement, setBaseStationIDStatement] = useState("");
  const [beaconIDError, setBeaconIDError] = useState(false);
  const [beaconIDErrorStatement, setBeaconIDErrorStatement] = useState("");
  const [disable, setDisable] = useState(true);
  const [baseStationList, setBaseStationList] = useState([]);
  const [beaconList, setBeaconList] = useState([]);
  const [baseStationID, setBaseStationID] = useState("");
  const [beaconID, setBeaconID] = useState("");
  const [btnText, setBtnText] = useState("Add");
  const [addResellerBtn, setAddResellerBtn] = useState(false);
  const [submitErr, setSubmitErr] = useState(false);
  const [submitErrStatement, setSubmitErrStatement] = useState("");
  const [loading, setLoading] = useState(false);
  const handleFileInput = useRef(null);
  const [column, setColumn] = useState([]);
  const [values, setValues] = useState([]);
  const [importDisabled, setImportDisabled] = useState(false);

  useEffect(() => {
    if (!visible) {
      setSubmitErr(false);
      setSubmitErrStatement("");
      setResellerID("");
      setBeaconList([]);
      setBaseStationList([]);
      setBtnText("Add");
      setDisable(true);
      setResellerIDError(false);
      setResellerIDStatement("");
      setBaseStationID("");
      setBaseStationIDError(false);
      setBaseStationIDStatement("");
      setAddResellerBtn(false);
      setLoading(false);
      setBeaconID("");
      setBeaconIDError(false);
      setBeaconIDErrorStatement("");
    }
  }, [visible]);

  useEffect(() => {}, [handleFileInput]);

  const Errors = (err) => {
    err.forEach((element) => {
      switch (element.split(":")[0]) {
        case "1":
          setResellerIDError(true);
          setResellerIDStatement(element.split(":")[1]);
          break;
        case "9":
          setResellerIDError(true);
          setResellerIDStatement(element.split(":")[1]);
          break;
        case "2":
          setResellerIDError(true);
          setResellerIDStatement(element.split(":")[1]);
          break;
        case "3":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "4":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "5":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "6":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        case "7":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        case "8":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        default:
          // setError(true)
          // setErrorText("An Error has occured")
          break;
      }
    });
  };

  const checkID2 = async () => {
    try {
      setLoading(true);
      setAddResellerBtn(true);
      const params = {
        TableName: "Resellers",
        Select: "COUNT",
        FilterExpression: "ResellerID = :id",
        ExpressionAttributeValues: {
          ":id": resellerID,
        },
      };
      const data = await dynamoDBClient.scan(params).promise();
      const count = data.Count;
      if (count === 0) {
        setSubmitErr(false);
        setDisable(false);
      } else {
        setResellerIDError(true);
        setResellerIDStatement("ResellerID Already Exists");
      }
      setAddResellerBtn(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const checkID = async () => {
    setAddResellerBtn(true);
    const formData = {
      resellerID,
    };
    await ResellerSchmea.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        checkID2();
      })
      .catch((err) => {
        setAddResellerBtn(false);
        Errors(err.errors);
      });
  };

  const handleBaseStationRemove = (index) => {
    const newIdArray = [...baseStationList];
    newIdArray.splice(index, 1);
    setBaseStationList(newIdArray);
  };

  const addBaseStation = async (id) => {
    setSubmitErr(false);
    const formData = {
      id,
    };
    await BaseStationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        setBaseStationList((prev) => {
          return [...prev, id];
        });
        setBaseStationID("");
      })
      .catch((err) => {
        Errors(err.errors);
      });
  };

  const handleBeaconRemove = (index) => {
    const newIdArray = [...beaconList];
    newIdArray.splice(index, 1);
    setBeaconList(newIdArray);
  };

  const addBeacon = async (id) => {
    setSubmitErr(false);
    const formData = {
      id,
    };
    await BeaconSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        setBeaconList((prev) => {
          return [...prev, id];
        });
        setBeaconID("");
      })
      .catch((err) => {
        Errors(err.errors);
      });
  };

  const addReseller2 = async () => {
    if (baseStationList.length > 0) {
      const params1 = {
        RequestItems: {
          Resellers: [],
        },
      };
      baseStationList.map((gatewayID) => {
        const uniqueId = uuidv4();
        params1.RequestItems.Resellers.push({
          PutRequest: {
            Item: {
              Id: uniqueId,
              ResellerID: resellerID,
              GatewayMAC: gatewayID,
              DateCreated: `${moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}`,
              BeaconMAC: "",
              DateUpdated: "",
            },
          },
        });
      });

      try {
        const result = await dynamoDBClient.batchWrite(params1).promise();
      } catch (error) {
        toast.error("Error While adding BaseStations", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
        setBtnText("Add");
        setDisable(false);
        throw new Error();
      }
    }

    if (beaconList.length > 0) {
      const params2 = {
        RequestItems: {
          Resellers: [],
        },
      };
      beaconList.map((beaconID) => {
        const uniqueId = uuidv4();
        params2.RequestItems.Resellers.push({
          PutRequest: {
            Item: {
              Id: uniqueId,
              ResellerID: resellerID,
              BeaconMAC: beaconID,
              DateCreated: `${moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}`,
              GatewayMAC: "",
              DateUpdated: "",
            },
          },
        });
      });

      try {
        const result2 = await dynamoDBClient.batchWrite(params2).promise();
      } catch (error) {
        toast.error("Error While adding Beacons", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
        setBtnText("Add");
        setDisable(false);
        throw new Error();
      }
    }

    toast("Reseller added sucessfully");
    setVisible(true);
  };

  const handelResellerError = (txt) => {
    setSubmitErrStatement(txt);
    setSubmitErr(true);
    setBtnText("Add");
  };

  const addReseller = async () => {
    setBtnText("Adding");
    if (baseStationList.length === 0 && beaconList.length === 0) {
      if (baseStationID === "" && beaconID === "") {
        handelResellerError("Must add atleast 1 Base Station or 1 Beacon");
        return;
      } else {
        handelResellerError(
          "Must Click on Add icon to add Base Station or Beacon"
        );
        return;
      }
    } else {
      if (baseStationID !== "") {
        handelResellerError("Must Click on Add icon to add Base Station");
        return;
      }

      if (beaconID !== "") {
        handelResellerError("Must Click on Add icon to add Beacon");
        return;
      }

      addReseller2();
    }
  };

  const parseCSV = (event) => {
    if (event.target.files?.length) {
      const file = event.target.files[0];
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const columnArray = [];
          const valuesArray = [];

          result.data.map((d) => {
            columnArray.push(Object.keys(d));
            valuesArray.push(Object.values(d));
          });

          valuesArray.map((d) => {
            setResellerID(d[0]);
            if (d[2] !== "") {
              const bs = d[2];
              setBaseStationList((prev) => {
                return [...prev, bs];
              });
            }
            if (d[4] !== "") {
              const beaconId = d[4];
              setBeaconList((prev) => {
                return [...prev, beaconId];
              });
            }
          });

          setImportDisabled(true);
        },
      });
    }
  };

  return (
    <Modal show={visible} onHide={setVisible}>
      <Modal.Header closeButton>
        <Modal.Title>
          <ResellerPageStyle>
            <h2 className="text-login">Add a Reseller</h2>
          </ResellerPageStyle>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ResellerPageStyle>
          <h6 className="text-login">Add Reseller id</h6>
          <div className="input-div">
            <input
              value={resellerID}
              onChange={(e) => {
                setResellerID(e.target.value);
                setResellerIDError(false);
                setResellerIDStatement("");
              }}
              disabled={!disable}
              maxLength={30}
              placeholder="Enter Reseller ID"
              className={
                resellerIDError
                  ? "form-control error-input"
                  : "form-control input-field"
              }
            />
            {loading && (
              <Spinner animation="border" size="sm" variant="secondary" />
            )}

            <i
              className={
                addResellerBtn
                  ? "bi bi-plus-circle add-icon disable-icon"
                  : "bi bi-plus-circle add-icon"
              }
              onClick={checkID}
              aria-disabled={!disable || addResellerBtn}
              title="Add Reseller"
            />
          </div>
          {resellerIDError && (
            <TextErrorStyle2>{resellerIDStatement}</TextErrorStyle2>
          )}

          {/* Add Base Station */}

          <h6 className="text-login">Add Base Stations</h6>
          <div className="input-div">
            <input
              value={baseStationID}
              onChange={(e) => {
                const value = e.target.value;
                setBaseStationID(value.toLocaleUpperCase());
                setBaseStationIDError(false);
                setBaseStationIDStatement("");
              }}
              disabled={disable}
              maxLength={12}
              placeholder="Enter Base Station MAC"
              className={
                baseStationIDError
                  ? "form-control error-input"
                  : "form-control input-field"
              }
            />
            <i
              className={
                disable
                  ? "bi bi-plus-circle add-icon disable-icon"
                  : "bi bi-plus-circle add-icon"
              }
              onClick={() => addBaseStation(baseStationID)}
              aria-disabled={disable}
              title="Add"
            />
          </div>
          {baseStationIDError && (
            <TextErrorStyle2>{baseStationIDStatement}</TextErrorStyle2>
          )}
          <IdListInput
            ids={baseStationList}
            onRemove={handleBaseStationRemove}
          />
          {/* Add Beacon */}

          <h6 className="text-login">Add Beacon</h6>
          <div className="input-div">
            <input
              value={beaconID}
              onChange={(e) => {
                const value = e.target.value;
                setBeaconID(value.toLocaleUpperCase());
                setBeaconIDError(false);
                setBeaconIDErrorStatement("");
              }}
              disabled={disable}
              placeholder="Enter Beacon MAC"
              maxLength={12}
              className={
                beaconIDError
                  ? "form-control error-input"
                  : "form-control input-field"
              }
            />
            <i
              className={
                disable
                  ? "bi bi-plus-circle add-icon disable-icon"
                  : "bi bi-plus-circle add-icon"
              }
              onClick={() => addBeacon(beaconID)}
              title="Add"
            />
          </div>
          {beaconIDError && (
            <TextErrorStyle2>{beaconIDErrorStatement}</TextErrorStyle2>
          )}
          <IdListInput ids={beaconList} onRemove={handleBeaconRemove} />
          {submitErr && <p className="text-error2">{submitErrStatement}</p>}
        </ResellerPageStyle>
      </Modal.Body>

      <Modal.Footer>
        <ResellerPageStyle>
          <input
            ref={handleFileInput}
            type="file"
            accept=".csv"
            onChange={parseCSV}
            style={{ display: "none", fontFamily: "medium-pro, sans-serif" }}
          />

          <button
            className="btn form-button3"
            disabled={importDisabled}
            onClick={() => handleFileInput.current.click()}
          >
            Import&ensp;<i className="bi bi-upload"></i>
          </button>
          <button
            className="btn form-button3"
            disabled={disable}
            onClick={addReseller}
          >
            {btnText}
          </button>

          <Button variant="secondary" onClick={setVisible}>
            <p className="bootstrap-btn">Close</p>
          </Button>
        </ResellerPageStyle>
      </Modal.Footer>
    </Modal>
  );
};

export default AddReseller;
